import { render, staticRenderFns } from "./CustomsDocs.vue?vue&type=template&id=c8ef95bc&scoped=true"
import script from "./CustomsDocs.vue?vue&type=script&lang=js"
export * from "./CustomsDocs.vue?vue&type=script&lang=js"
import style0 from "./CustomsDocs.vue?vue&type=style&index=0&id=c8ef95bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ef95bc",
  null
  
)

export default component.exports